module.exports = __webpack_public_path__ + "static/media/document.003e69e1.png";